import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback } from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

function BusinessTravellerInvitedUserModal() {
  const modalContext = useModalElementContext()

  const onOkClick = useCallback(() => {
    modalContext.resolve()
  }, [modalContext])

  return (
    <Modal
      title="Account already registered"
      primaryActionText="Ok"
      onPrimaryActionClick={onOkClick}
    >
      <Group direction="vertical" gap={12}>
        <BodyText variant="large">
          Your email is already registered for Business Traveller. Please activate your account using the invitation email.
        </BodyText>
        <BodyText variant="large">
          If you have not yet received the invitation email, contact your admin.
        </BodyText>
      </Group>
    </Modal>
  )
}

export default BusinessTravellerInvitedUserModal
